import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row } from 'reactstrap';
import propTypes from 'prop-types';

import Header from './Header';
import Footer from './Footer';
import Size from './Size';

export default class SizeInfo extends Component {

  render(){
    const availables = this.props.dataAvailableSize.filter((item, index) => (this.props.sell!==null?this.props.sell.size.id:null) === item.size_id);

    return(
      <div className="size-container">
        <Row>
          <Header>
            <h6>Size {this.props.category === "sneakers" ? "(US)" : null}</h6>
          </Header>
          <Size 
            selectedSize={this.props.sell.size}
            otherSize={availables}
            sell={this.props.sell}
            submitSize={this.props.submitSize}
          />
        </Row>
      </div>
    )
  }
}

SizeInfo.propTypes={
    product:propTypes.shape({
        id:propTypes.number.isRequired,
        colour:propTypes.string,
        SKU:propTypes.string,
    }),
    sell:propTypes.shape({
        id:propTypes.number.isRequired,
        size:propTypes.shape({
            id:propTypes.number,
            US:propTypes.any
        }),
        box_condition:propTypes.string,
    })
}
SizeInfo.defaultProps={
    product:{
        id:0,
        colour:'',
        SKU:'',
    },
    sell:{
        id:0,
        size:propTypes.shape({
            id:0,
            US:"0"
        }),
        box_condition:'SEMPURNA',
    },
    dataAvailableSize: []
}
